(function () {
  var ticking = false;
  var overlayOffsetSet = false;
  var compact = false;
  var savedLogoRowSize = 0;

  function headerSection() {
    return document.querySelector('.section-header');
  }

  function headingEl() {
    return document.querySelector('.header > .header__heading') || document.querySelector('.header > .header__heading-link');
  }

  function setOverlayOffset() {
    if (overlayOffsetSet) return;
    var header = headerSection();
    if (!header || !header.offsetHeight) return;
    document.documentElement.style.setProperty('--header-overlay-offset', header.offsetHeight + 'px');
    overlayOffsetSet = true;
  }

  function updateHeaderHeight() {
    var header = headerSection();
    if (!header) return;
    if (isHome() && overlayOffsetSet) return;
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }

  function applyLogoRowSize(size) {
    if (!size) return;
    savedLogoRowSize = size;
    document.documentElement.style.setProperty('--header-logo-row-size', size + 'px');
  }

  function restoreLogoRow() {
    applyLogoRowSize(savedLogoRowSize);
  }

  function measureLogoRow() {
    if (compact) return;
    var heading = headingEl();
    if (!heading) return;

    var size = heading.scrollHeight;
    var link = heading.matches && heading.matches('.header__heading-link')
      ? heading
      : heading.querySelector('.header__heading-link');
    if (link) size = Math.max(size, link.scrollHeight);
    var logo = heading.querySelector('.header__heading-logo');
    if (logo) {
      size = Math.max(size, Math.round(logo.getBoundingClientRect().height), logo.naturalHeight || 0);
    }

    if (!size) return;
    if (savedLogoRowSize && size < savedLogoRowSize * 0.9) return;
    applyLogoRowSize(size);
  }

  function setHeadingHidden(hidden) {
    var heading = headingEl();
    if (!heading) return;
    heading.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    var link = heading.tagName === 'A' ? heading : heading.querySelector('a');
    if (!link) return;
    if (hidden) link.setAttribute('tabindex', '-1');
    else link.removeAttribute('tabindex');
  }

  function isHome() {
    return document.body.classList.contains('template-index');
  }

  function updateHeader() {
    ticking = false;
    var y = window.scrollY;
    var next = compact ? y > 12 : y > 36;

    if (next !== compact) {
      compact = next;
      document.body.classList.toggle('header-is-compact', compact);
      setHeadingHidden(compact);
      if (!compact) restoreLogoRow();
    }

    if (!compact) setOverlayOffset();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeader);
  }

  setOverlayOffset();
  measureLogoRow();
  updateHeader();
  updateHeaderHeight();

  var section = headerSection();
  if (section && window.ResizeObserver) {
    new ResizeObserver(updateHeaderHeight).observe(section);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (!compact) measureLogoRow();
  });

  var logo = document.querySelector('.header__heading-logo');
  if (logo) {
    if (logo.complete) measureLogoRow();
    else logo.addEventListener('load', measureLogoRow);
  }
})();
